import { ColumnConfig, ColumnDataType } from '@aurora';

export const engineModelChartVariableColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'chartVariable.displayName',
        searchableField: '$chartVariable.displayName$',
        sort: 'chartVariable.displayName',
        translation: 'Display Name',
        isUnaccent: true,
    },
];
